module.exports = __webpack_public_path__ + "static/img/kcLogo.d8e8dd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kcLogo.png
// module id = JUmq
// module chunks = 16